import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
});

interface IDocumentUploadSubmitConfirmedProps {
}

interface IDocumentUploadSubmitConfirmedState {
}

export class DocumentUploadSubmitConfirmed extends Component<IDocumentUploadSubmitConfirmedProps & WithStyles<typeof styles>, IDocumentUploadSubmitConfirmedState> {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    public componentDidMount() {
    }

    public render() {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h2">
                                Secure Document Management
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Alert severity="success">
                        Thank you, your documents have now been uploaded.
                    </Alert>
                    <Typography>
                        You can now close this window.
                    </Typography>
                </Grid>
            </Grid>
        );
    }

}

export default withStyles(styles)(DocumentUploadSubmitConfirmed);

